/* NeoPlay — BU filters use Shopify tag filtering and server pagination. */
(function () {
  function init(root) {
    root.querySelectorAll('.np-bu-page[data-np-bu-collection]').forEach(function (page) {
      if (page.dataset.npBuFiltersBound) return;
      var content = page.querySelector('[data-np-bu-catalog-content]');
      var base = page.dataset.npBuCollection;
      if (!content || !base) return;
      page.dataset.npBuFiltersBound = 'true';
      var allTags = [];
      try { allTags = JSON.parse(page.querySelector('[data-np-bu-all-tags]').textContent) || []; } catch (error) {}
      var activeGame = '', activeType = '', activeFilter = '';
      var gameChoices = [], typeChoices = [], filterChoices = [], unionNext = [], unionIds = new Set();
      var gameScopeTags = [];
      var controller, requestId = 0;
      var errorBox = page.querySelector('[data-np-bu-error]');
      var heading = content.querySelector('h2')?.textContent;
      function handle(value) {
        return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      }
      function tagChoices(value, availableTags) {
        var aliases = String(value || '').split(',').map(handle).filter(Boolean);
        return aliases.filter(function (alias) { return (availableTags || allTags).some(function (tag) { return handle(tag) === alias; }); });
      }
      // Keep an unavailable selection distinct from the explicit "Tutto" option.
      function resolveTag(value) { return tagChoices(value)[0] || handle(String(value || '').split(',')[0]); }
      function syncPills() {
        page.querySelectorAll('[data-np-bu-filter]').forEach(function (button) {
          var value = button.dataset.filterTag || button.dataset.filter;
          button.hidden = !!value && !tagChoices(value).length;
        });
        page.querySelectorAll('[data-np-bu-game-filter]').forEach(function (button) {
          button.hidden = !!button.dataset.gameFilter && !tagChoices(button.dataset.gameFilter).length;
        });
        page.querySelectorAll('[data-np-bu-type-filter]').forEach(function (button) {
          button.hidden = !!button.dataset.typeFilter && !tagChoices(button.dataset.typeFilter, gameScopeTags).length;
        });
        showTypes();
      }
      function clearCatalogue(container) {
        var grid = container.querySelector('[data-np-bu-grid]');
        if (grid) grid.replaceChildren();
        container.querySelectorAll('.pagination-wrapper, [data-np-bu-more], .np-bu-filter-empty').forEach(function (node) { node.remove(); });
        var count = container.querySelector('[data-np-bu-count]'); if (count) count.textContent = '0 prodotti';
        if (grid) { var empty = document.createElement('p'); empty.className = 'np-bu-filter-empty'; empty.textContent = 'Nessun prodotto trovato per questi filtri.'; grid.after(empty); }
      }
      function readCatalogue(html, target) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-np-bu-catalog-response]');
        if (!next) throw new Error('Missing catalogue response');
        var appliedNode = next.querySelector('[data-np-bu-applied-tags]');
        if (!appliedNode) throw new Error('Missing applied filters');
        var applied = (JSON.parse(appliedNode.textContent) || []).map(handle);
        var basePath = new URL(base, location.origin).pathname.replace(/\/$/, '');
        var requested = target.pathname.slice(basePath.length).replace(/^\//, '').split('+').filter(Boolean).map(function (tag) { return handle(decodeURIComponent(tag)); });
        var accepted = applied.length === requested.length && requested.every(function (tag) { return applied.indexOf(tag) !== -1; });
        // Shopify can remove an unknown tag from the URL: never display that unfiltered response.
        if (!accepted) clearCatalogue(next);
        var tagNode = next.querySelector('[data-np-bu-current-tags]');
        return { node: next, tags: accepted && tagNode ? JSON.parse(tagNode.textContent) || [] : [] };
      }
      function pressed(selector, active) {
        page.querySelectorAll(selector).forEach(function (button) {
          button.classList.toggle('is-active', button === active);
          button.setAttribute('aria-pressed', button === active ? 'true' : 'false');
        });
      }
      function singleCardOnly(card) {
        if (activeType !== 'single-card' && activeType !== 'singole') return true;
        var tags = (card.dataset.tags || '').split(/\s+/);
        return !tags.some(function (tag) { return ['graded', 'gradate', 'gradato', 'gradati'].indexOf(tag) !== -1; });
      }
      function removeGradedSingles() {
        if (activeType !== 'single-card' && activeType !== 'singole') return;
        content.querySelectorAll('[data-np-bu-product]').forEach(function (card) { if (!singleCardOnly(card)) card.remove(); });
        var count = content.querySelector('[data-np-bu-count]');
        if (count) count.textContent = content.querySelectorAll('[data-np-bu-product]').length + ' prodotti in questa pagina';
      }
      function filteredUrl() {
        var tags = [activeGame, activeType, activeFilter].filter(Boolean);
        return base + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '');
      }
      function load(url) {
        if (controller) controller.abort();
        controller = new AbortController();
        var id = ++requestId;
        var target = new URL(url, location.origin);
        target.searchParams.set('view', 'np-bu-catalog');
        content.setAttribute('aria-busy', 'true');
        if (errorBox) errorBox.hidden = true;
        fetch(target, { signal: controller.signal })
          .then(function (response) { if (!response.ok) throw new Error('Catalog request failed'); return response.text(); })
          .then(function (html) {
            if (id !== requestId) return;
            var result = readCatalogue(html, target);
            var next = result.node;
            content.innerHTML = next.innerHTML;
            removeGradedSingles();
            if (heading && content.querySelector('h2')) content.querySelector('h2').textContent = heading;
            content.querySelectorAll('.pagination-wrapper a[href]').forEach(function (link) {
              var href = new URL(link.getAttribute('href'), target);
              href.searchParams.delete('view');
              link.href = href.pathname + href.search + '#np-bu-catalog';
            });
            if (errorBox) errorBox.querySelector('a').href = filteredUrl();
            // The type options belong to the whole selected game, across every page.
            // Keep this scope when a type is selected so sibling options stay available.
            if (!activeType) gameScopeTags = result.tags;
            syncPills();
          })
          .catch(function (error) { if (error.name !== 'AbortError' && id === requestId && errorBox) { errorBox.hidden = false; errorBox.querySelector('a').href = filteredUrl(); } })
          .finally(function () { if (id === requestId) content.removeAttribute('aria-busy'); });
      }
      function showTypes() {
        var row = page.querySelector('[data-np-bu-type-row]');
        if (row) row.hidden = !activeGame;
      }
      function unionUrls() {
        if ((activeGame && !gameChoices.length) || (activeType && !typeChoices.length) || (activeFilter && !filterChoices.length)) return [];
        var groups = [gameChoices, typeChoices, filterChoices].filter(function (group) { return group.length; });
        var combinations = groups.reduce(function (sets, group) { return sets.flatMap(function (set) { return group.map(function (tag) { return set.concat(tag); }); }); }, [[]]);
        return Array.from(new Set(combinations.map(function (tags) { return base + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : ''); })));
      }
      function loadUnion(urls, append) {
        if (controller) controller.abort();
        controller = new AbortController();
        var id = ++requestId;
        content.setAttribute('aria-busy', 'true');
        if (errorBox) errorBox.hidden = true;
        Promise.all(urls.map(function (url) {
          var target = new URL(url, location.origin); target.searchParams.set('view', 'np-bu-catalog');
          return fetch(target, { signal: controller.signal }).then(function (response) { if (!response.ok) throw new Error('Catalogue request failed'); return response.text(); }).then(function (html) {
            var result = readCatalogue(html, target);
            var next = result.node;
            var more = next.querySelector('.pagination__item--prev[href]');
            var nextUrl = more ? new URL(more.getAttribute('href'), target).href : null;
            return { cards: Array.from(next.querySelectorAll('[data-np-bu-product]')), next: nextUrl, tags: result.tags };
          });
        })).then(function (results) {
          if (id !== requestId) return;
          var grid = content.querySelector('[data-np-bu-grid]'); if (!grid) return;
          if (!append) { grid.innerHTML = ''; unionIds.clear(); }
          results.forEach(function (result) { result.cards.forEach(function (card) {
            var key = card.dataset.npProductId;
            if (singleCardOnly(card) && !unionIds.has(key)) { unionIds.add(key); grid.appendChild(card); }
          }); });
          unionNext = results.map(function (result) { return result.next; }).filter(Boolean);
          content.querySelectorAll('.pagination-wrapper, [data-np-bu-more], .np-bu-filter-empty').forEach(function (node) { node.remove(); });
          var count = content.querySelector('[data-np-bu-count]'); if (count) count.textContent = unionIds.size + ' prodotti mostrati';
          if (!unionIds.size) { var empty = document.createElement('p'); empty.className = 'np-bu-filter-empty'; empty.textContent = 'Nessun prodotto trovato per questi filtri.'; grid.after(empty); }
          if (unionNext.length) { var more = document.createElement('button'); more.type = 'button'; more.className = 'np-btn np-btn--outline'; more.dataset.npBuMore = ''; more.textContent = 'Carica altri prodotti'; grid.after(more); }
          if (!activeType && !append) gameScopeTags = Array.from(new Set(results.flatMap(function (result) { return result.tags; })));
          syncPills();
        }).catch(function (error) {
          if (error.name !== 'AbortError' && id === requestId && errorBox) { errorBox.hidden = false; errorBox.querySelector('a').href = filteredUrl(); }
        }).finally(function () { if (id === requestId) content.removeAttribute('aria-busy'); });
      }
      function loadSelection() {
        var urls = unionUrls();
        if (!urls.length) {
          if (controller) controller.abort();
          ++requestId;
          unionNext = []; unionIds.clear();
          clearCatalogue(content);
          content.removeAttribute('aria-busy');
          if (errorBox) errorBox.hidden = true;
          if (!activeType) gameScopeTags = [];
          syncPills();
        } else if (urls.length > 1) loadUnion(urls, false);
        else { unionNext = []; load(urls[0]); }
      }
      page.addEventListener('click', function (event) {
        var game = event.target.closest('[data-np-bu-game-filter]');
        var type = event.target.closest('[data-np-bu-type-filter]');
        var filter = event.target.closest('[data-np-bu-filter]');
        var pagination = event.target.closest('.np-bu-products-grid .pagination-wrapper a[href]');
        if (event.target.closest('[data-np-bu-more]')) { event.preventDefault(); if (!content.hasAttribute('aria-busy')) loadUnion(unionNext, true); return; }
        if (pagination) { event.preventDefault(); load(pagination.href); return; }
        if (!game && !type && !filter) return;
        event.preventDefault();
        if (game) {
          gameChoices = tagChoices(game.dataset.gameFilter); typeChoices = []; activeGame = resolveTag(game.dataset.gameFilter); activeType = '';
          gameScopeTags = [];
          var typeRow = page.querySelector('[data-np-bu-type-row]'); if (typeRow) typeRow.hidden = true;
          pressed('[data-np-bu-game-filter]', game);
          pressed('[data-np-bu-type-filter]', page.querySelector('[data-np-bu-type-filter]'));
          var label = page.querySelector('[data-np-bu-type-all-label]');
          if (label) label.textContent = activeGame ? 'Tutto ' + game.textContent.trim() : 'Tutto';
        } else if (type) { typeChoices = tagChoices(type.dataset.typeFilter, gameScopeTags); activeType = resolveTag(type.dataset.typeFilter); pressed('[data-np-bu-type-filter]', type); }
        else { filterChoices = tagChoices(filter.dataset.filterTag || filter.dataset.filter); activeFilter = resolveTag(filter.dataset.filterTag || filter.dataset.filter); pressed('[data-np-bu-filter]', filter); }
        loadSelection();
      });
      syncPills();
      page._npCleanup = function () { if (controller) controller.abort(); };
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('.np-bu-page').forEach(function (page) { if (page._npCleanup) page._npCleanup(); }); });
})();

